import { makeStyles, Theme } from "@material-ui/core"
import newColors from "@/styles/newColors"

const useStyles = makeStyles((theme: Theme) => ({
	textArea: {
		marginTop: theme.spacing(2)
	},
	blockButton: {
		backgroundColor: newColors.red[600],
		color: newColors.grey[0],
		"&:hover": {
			backgroundColor: newColors.red[700]
		}
	},
	unblockButton: {
		backgroundColor: newColors.green[600],
		color: newColors.grey[0],
		"&:hover": {
			backgroundColor: newColors.green[700]
		}
	},
	disabledActionButton: {
		backgroundColor: theme.palette.action.disabledBackground,
		color: theme.palette.action.disabled
	},
	"@global": {
		"#save-button-mass-block-subscription": {
			backgroundColor: `${newColors.red[600]} !important`,
			color: `${newColors.grey[0]} !important`,
			"&:hover": {
				backgroundColor: `${newColors.red[700]} !important`
			},
			"&:disabled": {
				opacity: 0.7,
				color: `${newColors.grey[0]} !important`
			}
		}
	}
}))

export default useStyles
